module.exports = __webpack_public_path__ + "static/img/content_box_title_bg.67c35013.png";